// extracted by mini-css-extract-plugin
module.exports = {"estateInfo":"ParcelDetail_estateInfo__2U0Mt"};